<div class="modal-header">
  <h2>{{'vocabulary.import-external.preview.title.' + entityType | translate}}</h2>
  <button type="button" class="btn-close"
    (click)="closeModal()" aria-label="Close">
    <span aria-hidden="true">×</span>
  </button>
</div>
<div class="modal-body">
  <div class="container">
    @if ((loading$ | async)) {
      <ds-loading></ds-loading>
    }
    @if ((loading$ | async) !== true && metadataList.length > 0) {
      <div>
        <div class="row">
          <div class="col-md-12">
            <p>{{'vocabulary.import-external.preview.subtitle' | translate}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <hr>
            </div>
          </div>
          @for (metadata of metadataList; track metadata) {
            <div class="row">
              <div class="col-md-12">
                <strong>{{'item.preview.' + metadata.key | translate}}</strong>
                <p>{{metadata.value}}</p>
              </div>
            </div>
          }
          <div class="row">
            <div class="col-md-12">
              <hr>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-end">
                <button class="btn btn-success" (click)="import()" role="button">
                  <i class="fa fa-file-import" aria-hidden="true"></i> {{'vocabulary.import-external.preview.button.import' | translate}}
                </button>
              </div>
            </div>
          </div>
        }
        @if ((loading$ | async) !== true && metadataList.length === 0) {
          <div>
            <ds-alert [type]="'alert-danger'" [content]="'vocabulary.import-external.preview.not-found'"></ds-alert>
          </div>
        }
      </div>
    </div>
